import React from 'react'

function InquiriesDetail() {
  return (
    <div>
      
    </div>
  )
}

export default InquiriesDetail
